<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />

    <div class="m-2" :style="`padding-inline-end:35px;margin-bottom:70px !important;direction:${lang.dir}`">
        <tabs-comp :tabs="tabs" />

        <v-row class="mt-2">
            <v-col
            cols="12"
            md="10"
            sm="12">
            </v-col>
            <v-col cols="12" md="2" sm="12" class="text-end pt-7" style="padding-inline-end:5px;">
            <b-button
                v-b-toggle.add_unit
                class="btn-sm btn "
                @click="resetAllValues({id: 0})"
                style="margin-top:9px;width:165px;background:transparent;border:none !important;margin-left:-7px !important;"
                id="multiply-button"
                >
                <div :class="`multiply-button-content-`+lang.lalgin" style="width:150px;border:none !important">{{lang.add_unit}}</div>
            </b-button>
            </v-col>
        </v-row>
        <v-row>

            <v-col cols="12" md="12" sm="12" >
                <v-simple-table>
                    <thead>
                        <tr>
                            <th class="text-center backBlack">{{ lang.unitId }}</th>
                            <th class="text-center backBlack">{{lang.namear}}</th>
                            <th class="text-center backBlack">{{lang.nameen}}</th>
                            <th class="text-center backBlack">{{lang.unit_type}}</th>
                            <th class="text-center backBlack">{{lang.main_unit_ar}}</th>
                            <th class="text-center backBlack">{{lang.main_unit_en}}</th>
                            <th class="text-center backBlack">{{ lang.delete }}</th>
                            <th class="text-center backBlack">{{ lang.action }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in units" :key="index">
                            <td class="text-center" :style="`direction:ltr;width:50px;`">{{item.id}}</td>
                            <td class="text-center" :style="`direction:ltr;`">{{item.namear}}</td>
                            <td class="text-center" :style="`direction:ltr;$`">{{item.nameen}}</td>
                            <td class="text-center" :style="`direction:ltr;`">{{item.unit_type}}</td>
                            <td class="text-center" :style="`direction:ltr;`">{{item.main_unit_ar}}</td>
                            <td class="text-center" :style="`direction:ltr;`">{{item.main_unit_en}}</td>
                            <td class="text-center" @click="delUnit(item)" :style="`direction:ltr;width:70px;background:red !important; color:#fff !important;cursor:pointer;border:1px solid #fff !important;`">{{lang.delete}}</td>
                            <td class="text-center" v-b-toggle.add_unit @click="resetAllValues(item)" :style="`direction:ltr;width:70px;background:blue !important; color:#fff !important;cursor:pointer;border:1px solid #fff !important;`">{{lang.update}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <vue-snotify></vue-snotify>
        <Footer />
        <addUnit ref="addUnit" />
    </div>
    </div>
</template>

<script>
import TabsComp from '@/components/tabsComp.vue';
import axios from 'axios'
import HeaderPortrate from '@/components/Header-Portrate.vue';
import addUnit from '@/components/add_unit.vue'
import Footer from '@/components/Footer.vue';
import ExportsPrint from '@/components/exports-print.vue';
import {SnotifyPosition} from 'vue-snotify';
import { getVisibleTabsForRoute } from '@/menu/menuService'
export default {
  components: { TabsComp, HeaderPortrate,Footer,addUnit,ExportsPrint},
    data()
     {
        return {
            units: [],

        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        items: function(){
            return {
                    text: this.lang.account_statement,
                    disabled: true,
                    to: '/reports/statment-report',
                }
        },
        tabs: function() {

            return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

        },
        headers: function(){
            return '';
        }
    },
    created() {
       this.getUnits();
    //    this.getRep();
    },
    methods: {
        collectSearch(){
          return {
              module: 'inventoryUnits',
              elements: {
                  status: 1
              }
          }
        },
        delUnit(item){
            if(!confirm(this.lang.are_you_sure)){
                return false;
            }
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','delUnits');
            post.append('auth',cook);
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',item.id)
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                this.getUnits();
                this.$snotify.error(this.lang[response.data.error.message], this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                // this.getUnits();

            })
        },
        getUnits(){
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getUnits');
            post.append('auth',cook);
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[units]',0)
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                if(response && response.data && response.data.results){
                    this.units = response.data.results.data;
                }
            })
        },
        resetAllValues(item){
            // console.log(item);
            if(item.id == 0){
                this.$refs.addUnit.resetValues({
                    title: this.lang.add_unit,
                    unit: {
                        id: 0,
                        namear: '',
                        nameen: '',
                        main_unit: 0,
                        type: 1,
                        qty: 1,
                    }
                })
            }else{
                this.$refs.addUnit.resetValues({
                    title: this.lang.update_units,
                    unit: {
                        id: item.id,
                        namear: item.namear,
                        nameen: item.nameen,
                        main_unit: item.main_unit,
                        type: item.type,
                        qty: item.qty,
                    }
                })
            }
        }
    },
}
</script>